import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@arcadeai/design-system/components/ui/atoms/alert";
import { ShieldAlert } from "lucide-react";
import type { Server } from "@/app/servers/types";
import { OAuthActionButton } from "./oauth-action-button";
import { OAuthAuthorizationSheet } from "./oauth-authorization-sheet";

type OAuthRequiredAlertProps = {
  server: Server;
};

export const OAuthRequiredAlert = ({ server }: OAuthRequiredAlertProps) => (
  <Alert className="mb-6 border-amber-500 bg-amber-50 dark:bg-amber-950/30">
    <ShieldAlert className="size-4 text-amber-600 dark:text-amber-400" />
    <AlertTitle className="text-amber-900 dark:text-amber-100">
      Authorization Required
    </AlertTitle>
    <AlertDescription className="mt-2 flex flex-col gap-3 text-amber-800 dark:text-amber-200">
      <p className="text-sm">
        This MCP server requires authorization to function properly.
      </p>
      <OAuthAuthorizationSheet server={server}>
        <OAuthActionButton size="sm" variant="default" />
      </OAuthAuthorizationSheet>
    </AlertDescription>
  </Alert>
);
